import Dashboard from "./dashboard"

/**
 * Product dashboard entry. Every switcher product lands on the shared
 * dashboard shell — there is no coming-soon gate.
 */
export default function ProductDashboard() {
  return <Dashboard />
}
